import { Component } from '@angular/core'

@Component({
  selector: 'app-pdf-icon',
  templateUrl: './pdf-icon.component.html',
  styleUrls: ['./pdf-icon.component.scss'],
  standalone: true,
  imports: []
})
export class PdfIconComponent {
  constructor() {}
}
